import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class BookingPaymentID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
